import { ReferralsIcon } from "../../../../assets"
import styles from "./style.module.css"

export const ReferralButton = () =>{

    return(

        <div className={styles.container}>
            <ReferralsIcon 
            className={styles.icon}
            />
            Referral
        </div>

    )

}